import { useCallback } from 'react';

import Drawer from '@mui/material/Drawer';

import { DrawerContent } from './AddLocationDrawerV2.styles';
import { AddLocationsV2 } from './AddLocationV2';
import { ProviderFileUploadV2 } from './ProviderFileUploadV2';

export const AddLocationDrawerV2 = ({ mode, setMode, onSuccessAdd, onRefreshTransactions }) => {
  const closeDrawer = useCallback(() => setMode(null), [setMode]);
  const switchToSingleLocation = useCallback(() => setMode('add-single-location'), [setMode]);

  return (
    <Drawer open={!!mode} onClose={closeDrawer} anchor="right">
      <DrawerContent>
        {mode === 'add-single-location' && (
          <AddLocationsV2
            closeDrawer={closeDrawer}
            onSuccess={onSuccessAdd}
            onRefreshTransactions={onRefreshTransactions}
          />
        )}
        {mode === 'add-multiple-locations' && (
          <ProviderFileUploadV2
            closeDrawer={closeDrawer}
            switchToSingleLocation={switchToSingleLocation}
          />
        )}
      </DrawerContent>
    </Drawer>
  );
};
